(function() {
    'use strict';
    
a3_cabin_reports.factory('AircraftDifferencesFactory', AircraftDifferencesFactory)

    /**
    * @memberof CabinReports
    * @ngdoc factory
    * @name AircraftDifferencesFactory
    * @description 
    *   Add, Update, Delete and Get AircraftDifferences.
    * @ngInject
    */
function AircraftDifferencesFactory(GenericService,FlightFactory) {
    
        /**
        * Initialize the AircraftPositions
        * @memberof AircraftDifferencesFactory
        */
		function AircraftDifferences() {
            
            this.GetId = GetId;
		}
    
				
		var objType = 'AircraftDifferences';
		var objCallback = AircraftDifferences; 
		
		var service = 
		{  
			getAircraftDifferencesFromStorage : getAircraftDifferencesFromStorage,
			setAircraftDifferencesToStorage : setAircraftDifferencesToStorage,
			clearAircraftDifferencesFromStorage : clearAircraftDifferencesFromStorage,
            getAircraftDifferencesByFlightId : getAircraftDifferencesByFlightId,
            getAircraftDifferenceFromStorageByRegistration : getAircraftDifferenceFromStorageByRegistration,
            upsertAircraftDifferences : upsertAircraftDifferences
		};

        /**
         * Override default get Id
         * @memberof AircraftDifferencesFactory
         * @returns {number} Id 
         */
		function GetId() {
			return this.Registration;
		}
				
    
    
        /**
         * Get messages
         * @memberof AircraftDifferencesFactory
         * @returns {Array} Aircraft Differences 
         */
		function getAircraftDifferencesFromStorage() {
			return GenericService.list(objType,objCallback);
        }
        
        function getAircraftDifferenceFromStorageByRegistration(registration) {
            return GenericService.get(registration,objType,objCallback);
		}

        /**
         * Save Aircraft Differences to storage
         * @memberof AircraftDifferencesFactory
         * @param {Array} messages A list of Aircraft Differences
         */
		function setAircraftDifferencesToStorage(aircraftDifferences) {
			GenericService.saveAll(aircraftDifferences,objType,objCallback);
		}

        /**
         * Remove the Aircraft Differences of  the local storage
         * @memberof AircraftDifferencesFactory
         */
		function clearAircraftDifferencesFromStorage() {
			GenericService.removeAll(objType,objCallback);
		}
    
        /**
         * Get Aircraft Differences of this flight
         * @memberof AircraftDifferencesFactory
         * @returns {Object} Aircraft Differences 
         */
		function getAircraftDifferencesByFlightId(flightId) {
            var retVal= [];
            var flight = FlightFactory.getFlightFromStorage(flightId);
            if (!flight) {
                flight = FlightFactory.getLocalFlightFromStorage(flightId);
            }

            if (!flight) {
                return [];
            }
            
            var difference = getAircraftDifferenceFromStorageByRegistration(flight.AcTailNo);
                    
            retVal = difference != null && difference.AircraftDifferences  != null ? difference.AircraftDifferences : []; 

            return retVal;
			// return GenericService.get(flightId,objType,objCallback);
		}
    
        /**
         * Upsert aircraft differences
         * @memberof AircraftDifferencesFactory
         */
        function upsertAircraftDifferences(aircraftDifferences) {
            var newAircraftDifferences = aircraftDifferences.map(x => x.Registration);
            var aircraftDifferencesLS = this.getAircraftDifferencesFromStorage();
            aircraftDifferencesLS = aircraftDifferencesLS.filter(x => !newAircraftDifferences.includes(x.Registration));
            var updatedAircraftDifferences = aircraftDifferencesLS.concat(aircraftDifferences);
            setAircraftDifferencesToStorage(updatedAircraftDifferences);
        }       

	return service;
	}

})();